import React, { useEffect, useState } from 'react'
import SAModal from '../../../Common/Custom Components/Ant design/SAModal'
import { Spin, Table } from 'antd';
import DashboardService from '../../../Services/DashboardService';
import { LoadingOutlined } from '@ant-design/icons';

interface IProps {
  fromDate: string,
  toDate: string
  open: boolean,
  onCancel: () => void,
}
const IncommingStatsModal = ({ open, onCancel, fromDate, toDate }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [incommingStatsData, setIncommingStatsData] = useState([]);
  const [listParams, setListParams] = React.useState({
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
  });

  const getIncommingStatsDetails = async () => {
    try {
      setLoading(true)
      const res = await DashboardService.getIncommingStatsDetails((listParams.currentPage - 1) * listParams.pageSize, listParams.pageSize, fromDate, toDate)
      if (res?.result && res?.status && res?.result?.items) {
        setIncommingStatsData(res?.result?.items)
        setListParams({
          ...listParams,
          totalRecords: res?.result?.totalRecords,
        })
      }
    } catch (error) {
      console.error(error)
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getIncommingStatsDetails()
  }, [listParams.currentPage,listParams.pageSize])

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "10%",
    },
    {
      title: "Tenant",
      dataIndex: "tenantsId",
      key: "tenantsId",
      width: "20%",
      render: (_: any, record: any, index: any) => (
        <p>{`Tenant ${record.tenantsId}`}</p>
      ),
    },
    {
      title: "Practice",
      dataIndex: "practice",
      key: "practice"
    },
    {
      title: "Incomming Calls",
      dataIndex: "incomming",
      key: "incomming",
      width: "20%"
    },

  ];
  return (
    <SAModal width={800}  title={"Incomming Stats"} open={open} onCancel={onCancel} footer={false}>
      <Table columns={columns} size='small' dataSource={incommingStatsData}
       onChange={(paging, filter, sort: any) => {
        if (
          paging?.current !== undefined &&
          paging?.pageSize !== undefined
        ) {
          setLoading(true);
          setListParams({
            ...listParams,
            currentPage:
              paging.current !== undefined ? paging.current : 1,
            pageSize:
              paging.pageSize !== undefined ? paging.pageSize : 15,
          });
        }
      }}
       pagination={{
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          current: listParams.currentPage,
          pageSize: listParams.pageSize,
          showSizeChanger: true,
          total: listParams.totalRecords,
          pageSizeOptions: ["15", "25", "50", "100"],
        }}
        loading={{
          spinning: loading,
          size: "small",
          indicator: (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
            />
          ),
        }} />
    </SAModal>
  )
}

export default IncommingStatsModal